import { useContext, useState, useRef, useMemo, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { t } from 'ttag'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import { Button as ButtonComponent } from '@h2/components/buttons/button'
import { Text } from '@h2/components/typography/text'
import { GravatarIcon } from '@h2/common/components/gravatarIcon'
import { PB90T, PB97T, WHITE, BLACK, SLB } from '@h2/components/colors'
import { features } from '@h2/components/media'
import { Globals } from '@h2/globals'

import { Menu } from './menu'

import { useCallbackOnEventOutside } from '../../hooks/useCallbackOnEventOutside'

const Button = styled(ButtonComponent)`
  border: 1px solid transparent;
  border-radius: 0;
  gap: 8px;

  > span:last-child {
    margin: 0;
  }

  > span:first-child > span:first-child {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &.active {
    background-color: white;

    > span:first-child span {
      color: ${BLACK};
    }
  }
`
const Wrap = styled.div`
  height: 100%;

  > ${Button} {
    ${({ isEarlyLearnerMode }) =>
      isEarlyLearnerMode ? `background-color: ${SLB};` : null}

    &:hover {
      ${({ isEarlyLearnerMode }) =>
        isEarlyLearnerMode ? `background-color: ${SLB};` : null}
    }
  }

  @media (${features.minWidth.laptop}) {
    && {
      > ${Button} {
        background-color: ${({ isEarlyLearnerMode }) =>
          isEarlyLearnerMode ? SLB : PB90T};
      }

      &:hover {
        > ${Button} {
          background-color: ${({ isEarlyLearnerMode }) =>
            isEarlyLearnerMode ? SLB : PB97T};
        }
      }
    }
  }
`
const UserDisplayName = styled.span`
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
const Icon = props => <GravatarIcon isForUserInSession {...props} />
const Profile = () => {
  const ref = useRef()
  const history = useHistory()
  const [isActive, setIsActive] = useState(false)
  const { isEarlyLearnerMode, userProfile } = useContext(Globals)

  useCallbackOnEventOutside(
    useMemo(() => [ref], [ref]),
    useCallback(() => {
      if (isActive) {
        setIsActive(false)
      }
    }, [isActive, setIsActive])
  )

  useEffect(() => {
    const unlisten = history.listen(() => {
      setIsActive(false)
    })

    return () => unlisten()
  }, [history])

  return (
    <Wrap ref={ref} id="profile-wrap" isEarlyLearnerMode={isEarlyLearnerMode}>
      <Button
        isFullHeight
        align="right"
        variant="outlined"
        aria-expanded={isActive}
        icon={!isEarlyLearnerMode ? Icon : null}
        size="medium"
        className={isActive ? 'active' : null}
        onClick={() => setIsActive(!isActive)}
        isEarlyLearnerMode={isEarlyLearnerMode}>
        <Text
          as="span"
          size={isEarlyLearnerMode ? 'large' : 'medium'}
          weight="bold"
          color={isEarlyLearnerMode ? WHITE : BLACK}>
          <UserDisplayName>{`${t`Hi`} ${userProfile.userDisplayName}`}</UserDisplayName>
          <FontAwesomeIcon icon="chevron-down" />
        </Text>
      </Button>
      {isActive && <Menu />}
    </Wrap>
  )
}

export { Profile }
